import { toQueryParams } from '@/helpers/ApiHelper'
import type { IExcelColumn } from '@/models/Filtering/ExcelExportFilter'
import type { IResultsPage } from '@/models/Pagination/IResultsPage'
import type { IWorkOrderFilter } from '@/models/WorkOrder/Filtering/IWorkOrderFilter'
import type { IWorkOrder } from '@/models/WorkOrder/IWorkOrder'
import { inject, injectable } from 'inversify'
import type IApiClient from '../IApiClient'
import { SERVICES_TYPES } from '../ServicesTypes'
import type IWorkOrderService from './IWorkOrderService'

@injectable()
export class WorkOrderService implements IWorkOrderService {
  private readonly apiClient: IApiClient
  private readonly workOrdersUri: string = 'work-orders'

  constructor(@inject(SERVICES_TYPES.ApiClient) apiClient: IApiClient) {
    this.apiClient = apiClient
  }

  public async getWorkOrders(filters?: IWorkOrderFilter, abortController?: AbortController): Promise<IResultsPage<IWorkOrder>> {
    const queryParam = filters ? toQueryParams<IWorkOrderFilter>(filters) : ''
    return this.apiClient.get<IResultsPage<IWorkOrder>>(`${this.workOrdersUri}?${queryParam}`, abortController)
  }

  public async getWorkOrder(workOrderNumber: string): Promise<IWorkOrder> {
    return this.apiClient.get<IWorkOrder>(`${this.workOrdersUri}/${workOrderNumber}`)
  }

  public async getWorkOrderForCase(caseNumber: string, filters?: IWorkOrderFilter): Promise<IResultsPage<IWorkOrder>> {
    const queryParam = filters ? toQueryParams<IWorkOrderFilter>(filters) : ''
    return this.apiClient.get<IResultsPage<IWorkOrder>>(`case/${caseNumber}/${this.workOrdersUri}?${queryParam}`)
  }

  public async exportWorkOrders(size: number, columnList: IExcelColumn[], filters?: IWorkOrderFilter): Promise<{ blob: Blob; fileName?: string }> {
    const queryParam = filters ? toQueryParams<IWorkOrderFilter>(filters) : ''
    return this.apiClient.postBlobWithFileName(`${this.workOrdersUri}/download/${size}?${queryParam}`, columnList)
  }

  public async exportWorkOrdersForCase(caseNumber: string, size: number, columnList: IExcelColumn[], filters?: IWorkOrderFilter): Promise<{ blob: Blob; fileName?: string }> {
    const queryParam = filters ? toQueryParams<IWorkOrderFilter>(filters) : ''
    return this.apiClient.postBlobWithFileName(`case/${caseNumber}/${this.workOrdersUri}/download/${size}?${queryParam}`, columnList)
  }
}
